// 异常的小零件：类型色点、异常对象（组件 / 产品 + 套装名）、标题。发货批次详情的「关联异常」也用这些。
import { money, num, qty } from '@/lib/format';
import type { ExceptionBase } from './types';
import { typeOf } from './status';
import s from './ExceptionBits.module.css';

/** 类型：色点 + 文字（次级信息，不占实底标签） */
export function TypeMark({ type, big }: { type: string; big?: boolean }) {
  const t = typeOf(type);
  return <span className={[s.mark, s[t.tone], big && s.big].filter(Boolean).join(' ')}>{t.label}</span>;
}

/** 异常挂在谁身上：套装异常登记在组件行上（product = 组件），bundle / sourceBundleName 是套装上下文 */
export function targetOf(e: Pick<ExceptionBase, 'product' | 'bundle' | 'sourceBundleName' | 'orderLine'>) {
  const bundle = e.bundle?.name || e.sourceBundleName || e.orderLine?.sourceBundleName || null;
  if (e.product) return { name: e.product.name, code: e.product.code, bundle, bundleCode: e.bundle?.code };
  if (bundle) return { name: bundle, code: e.bundle?.code, bundle: null, bundleCode: undefined };
  return { name: '未关联产品', code: undefined, bundle: null, bundleCode: undefined };
}

/** 「数据线 Type-C 破损 12 个」：数量单位一律「个」（按组件登记，不写「套」） */
export function titleOf(e: Pick<ExceptionBase, 'product' | 'bundle' | 'sourceBundleName' | 'orderLine' | 'type' | 'quantity'>) {
  return `${targetOf(e).name} ${typeOf(e.type).label} ${qty(e.quantity)} 个`;
}

/**
 * 处理涉及的金额（退款 / 赔付 / 扣款 / 补发运费），只列非零项。
 * 注意：/api/order-exceptions 没有按权限裁掉这几个字段，调用方必须先判断 orders.amount.read（与订单金额同一权限）。
 */
export function amountRows(e: Pick<ExceptionBase, 'refundAmount' | 'compensationAmount' | 'claimAmount' | 'deductionAmount' | 'reshipShippingFee'>): [string, string][] {
  const rows: [string, unknown][] = [
    ['退款', e.refundAmount],
    ['索赔', e.claimAmount],
    ['已回收赔付', e.compensationAmount],
    ['扣款', e.deductionAmount],
    ['补发运费', e.reshipShippingFee],
  ];
  return rows.filter(([, v]) => num(v) > 0).map(([k, v]) => [k, money(v)]);
}

/** 套装上下文：描边小标，与实底状态标签区分 */
export function KitNote({ name, code }: { name: string; code?: string | null }) {
  return (
    <span className={s.kit} title={code ? `${name}（${code}）` : name}>
      <i>套装</i>{name}
    </span>
  );
}
